import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  reuseTelegramNotificationLink,
  saveTelegramNotificationSettings,
  sendTelegramNotificationTest,
  startTelegramNotificationLink,
  unlinkTelegramNotifications,
} from "@/api/telegramNotifications";
import { TelegramNotificationQueryKeys } from "@/tanstackQuery/queries/telegramNotifications";

// Link, settings and test outcomes all change what the page shows: refresh
// the state, and the log (a test or a block lands there).
const useRefreshTelegramNotifications = () => {
  const queryClient = useQueryClient();
  return () =>
    Promise.all([
      queryClient.invalidateQueries({
        queryKey: [TelegramNotificationQueryKeys.State],
      }),
      queryClient.invalidateQueries({
        queryKey: [TelegramNotificationQueryKeys.Log],
      }),
    ]);
};

export const useStartTelegramNotificationLink = () =>
  useMutation({ mutationFn: startTelegramNotificationLink });

export const useReuseTelegramNotificationLink = () => {
  const refresh = useRefreshTelegramNotifications();
  return useMutation({
    mutationFn: reuseTelegramNotificationLink,
    onSuccess: refresh,
  });
};

export const useUnlinkTelegramNotifications = () => {
  const refresh = useRefreshTelegramNotifications();
  return useMutation({
    mutationFn: unlinkTelegramNotifications,
    onSuccess: refresh,
  });
};

export const useSaveTelegramNotificationSettings = () => {
  const refresh = useRefreshTelegramNotifications();
  return useMutation({
    mutationFn: saveTelegramNotificationSettings,
    onSuccess: refresh,
  });
};

export const useSendTelegramNotificationTest = () => {
  const refresh = useRefreshTelegramNotifications();
  return useMutation({
    mutationFn: sendTelegramNotificationTest,
    onSuccess: refresh,
  });
};
